import BaseStore from './BaseStore'

export class SearchDocumentStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'search_documents'
  }
}

export default new SearchDocumentStore()


// WEBPACK FOOTER //
// ./src/stores/SearchDocumentStore.js